import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#333'
    },
    secondary: {
      main: '#fff'
    },
    plusButton: {
      main: '#0BA5EC'
    }
  }
});

export default theme;



// WEBPACK FOOTER //
// ./src/components/materialFunctions/Theme.js